const __WEBPACK_NAMESPACE_OBJECT__ = flarum.reg.get('fof-forum-widgets-core', 'common/components/Widget');